import { createAsyncThunk } from '@reduxjs/toolkit';
import { REDUX_ACTION, selectApi, setReduxAction, SilentThunkError } from '@socialive/common';
import { selectUploads } from '~/selectors';

const initMultipartUpload = createAsyncThunk(
  'uploads/initMultipartUpload',
  async ({ id, bucket, originalname, optionalData = {}, headers = {}, trigger }, { dispatch, getState }) => {
    const api = selectApi(getState());
    if (!api) throw new Error('API is required');

    const { canceling } = selectUploads(getState())[id] ?? {};
    if (canceling) throw new SilentThunkError(`upload ${id} canceled`);

    return api(`/s3-secure/multipart/init/${bucket}/${id}/${originalname}`, {
      method: 'POST',
      data: {
        originalname,
        ...optionalData,
      },
      headers: { 'x-api-version': '3.0', ...headers },
    });
  }
);

setReduxAction(REDUX_ACTION.INIT_MULTIPART_UPLOAD, initMultipartUpload);

export default initMultipartUpload;
